export const SET_LISTING = 'SET_LISTING';
export const SET_SLIDER_BTNS = 'SET_SLIDER_BTNS'
